import React, { useState } from 'react';
import { useClosingAssistant } from '../../contexts/ClosingAssistantContext';
import { InsightsPanel } from '../closing-assistant/InsightsPanel';
import { CustomerProfilePanel } from '../closing-assistant/CustomerProfilePanel';
import { ClosingReadinessPanel } from '../closing-assistant/ClosingReadinessPanel';
import { ClosingSuggestionsPanel } from '../closing-assistant/ClosingSuggestionsPanel';
import { SettingsPanel } from '../closing-assistant/SettingsPanel';
export const ClosingTab: React.FC = () => {
  const [activeSection, setActiveSection] = useState('readiness');
  return <div className="h-full" data-id="element-210">
      {/* Inner tabs for closing coach sections */}
      <div className="flex border-b border-gray-200" data-id="element-211">
        <button className={`flex-1 py-2 text-xs font-medium ${activeSection === 'readiness' ? 'text-blue-600 border-b-2 border-blue-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveSection('readiness')} data-id="element-212">
          Readiness
        </button>
        <button className={`flex-1 py-2 text-xs font-medium ${activeSection === 'suggestions' ? 'text-blue-600 border-b-2 border-blue-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveSection('suggestions')} data-id="element-213">
          Suggestions
        </button>
        <button className={`flex-1 py-2 text-xs font-medium ${activeSection === 'profile' ? 'text-blue-600 border-b-2 border-blue-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveSection('profile')} data-id="element-214">
          Profile
        </button>
        <button className={`flex-1 py-2 text-xs font-medium ${activeSection === 'insights' ? 'text-blue-600 border-b-2 border-blue-500' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveSection('insights')} data-id="element-215">
          Insights
        </button>
      </div>
      {/* Content area */}
      <div className="h-[calc(100%-2.5rem)] overflow-y-auto" data-id="element-216">
        {activeSection === 'readiness' && <ClosingReadinessPanel data-id="element-217" />}
        {activeSection === 'suggestions' && <ClosingSuggestionsPanel data-id="element-218" />}
        {activeSection === 'profile' && <CustomerProfilePanel data-id="element-219" />}
        {activeSection === 'insights' && <InsightsPanel data-id="element-220" />}
      </div>
    </div>;
};